module.exports = __webpack_public_path__ + "static/media/upcoming-stone-active.a2cf32c7.svg";